import { reactive, watch } from 'vue';
import { debounce } from '@vaaas/fpts/timing';
import type { Store } from '@phi/util/store';

/** a vue reactive object that is periodically saved to disk
 * and also loaded from disk
 */
export default async <T extends Record<string, any>>(store: Store, key: string, initial: T) => {
    const existing = await store.load(key);
    const record = reactive(existing ?? initial) as T;
    if (!existing)
        await store.save(key, record);

    const debounced_save = debounce((x: T) => store.save(key, x), 50);

    watch(
        () => record,
        debounced_save,
        {
            deep: true,
        },
    );

    return record;
};
